export default __webpack_public_path__ + "static/media/cr.c6fe5d48.svg";